import $ from 'jquery'

export function initSupplierSearchLanding () {
  const sliderSelector = '.resources'

  const mqMdDown = window.matchMedia('(max-width: 639px)')
  const mqLarge = window.matchMedia('(min-width: 1024px)')

  const slider = {
    init () {
      this.resourceSlider = null
      this.isSetup = false

      if (!$(sliderSelector).length) return

      if (mqMdDown.matches) {
        this.setup()
      }

      mqMdDown.addListener((e) => {
        e.matches ? this.setup() : this.destroy()
      })
    },

    setup () {
      if (!this.isSetup && window.tns) {
        this.resourceSlider = window.tns({
          container: sliderSelector,
          slideBy: 'page',
          fixedWidth: 316,
          edgePadding: 20,
          loop: false,
          controls: false,
          navPosition: 'bottom'
        })

        this.isSetup = true
      }
    },

    destroy () {
      if (this.isSetup && this.resourceSlider) {
        this.resourceSlider.destroy()
        this.isSetup = false
      }
    }
  }

  const search = {
    init () {
      this.$supplierSearch = $('.supplier-search.landing')
      if (!this.$supplierSearch.length) return

      this.$supplierSearchForm = this.$supplierSearch.find('.form')
      this.$takeoverClose = this.$supplierSearchForm.find('.close')
      this.$supplierInput = this.$supplierSearch.find('#supplier-search-box')
      this.$autocompleteContainer = this.$supplierSearchForm.find('.supplier-autocomplete')

      const debounce =
        window.Foundation && window.Foundation.util && window.Foundation.util.debounce
          ? window.Foundation.util.debounce
          : (fn) => fn

      this.$supplierInput
        .on('keyup', debounce(this.handleKeyup.bind(this)))
        .on('focus', this.handleFocus.bind(this))

      this.$takeoverClose.on('click', this.closeTakeover.bind(this))

      if (mqLarge.matches) {
        this.animateText()
      }
    },

    animateText () {
      const $highlightContainer = this.$supplierSearch.find('.highlights')
      const $activeHighlight = $highlightContainer.find('.active')
      if (!$highlightContainer.length || !$activeHighlight.length) return

      const initialWidth = $activeHighlight.width()
      $highlightContainer.width(initialWidth)

      const nextHighlight = () => {
        if ($activeHighlight.next().length > 0) {
          return $activeHighlight.next()
        } else {
          return $highlightContainer.children().first()
        }
      }

      setInterval(() => {
        const width = nextHighlight().width()

        $highlightContainer.width(width)
        $activeHighlight.css('opacity', 0)
        nextHighlight().css('opacity', 1)

        setTimeout(() => {
          $activeHighlight.removeClass('active')
          nextHighlight().addClass('active')
        }, 750)
      }, 4000)
    },

    handleKeyup (e) {
      const target = e.currentTarget
      const keyword = target.value

      if (keyword.length < 2) {
        this.hideAutocomplete()
        return
      }

      $.ajax({
        url: '/suppliers/search_by_name?search=' + encodeURIComponent(keyword),
        dataType: 'json'
      }).done((data) => {
        this.clearAutocomplete()

        if (data.length) {
          let results = '<ul>'

          for (let i = 0; i < data.length; i++) {
            const item = data[i]
            results += `<li><a href="${item.path}?search=${encodeURIComponent(keyword)}">${item.name}</a></li>`
          }

          results += '</ul>'

          this.$autocompleteContainer.addClass('visible').append(results)
        } else {
          this.hideAutocomplete()
        }
      })
    },

    handleFocus () {
      this.$supplierSearchForm.addClass('takeover')
    },

    closeTakeover () {
      this.clearAutocomplete()
      this.hideAutocomplete()
      this.$supplierSearchForm.removeClass('takeover')
    },

    clearAutocomplete () {
      this.$autocompleteContainer.find('ul').remove()
    },

    hideAutocomplete () {
      this.$autocompleteContainer.removeClass('visible')
    }
  }

  slider.init()
  search.init()
}
